import { useClipboard } from '@perpay-web/fintech/hooks/useClipboard';
import { noop } from '@perpay-web/utils/noop';

import styles from './CopyIconButton.scss';

const CopyIconButton = ({
    textElementRef,
    valueGetter,
    childGetter,
    onClick = noop,
    onCopySuccess,
    onCopyFail,
    ...rest
}) => {
    const { state, setClipboard } = useClipboard();

    return (
        <button
            type='button'
            {...rest}
            onClick={() => {
                onClick();
                setClipboard(textElementRef, valueGetter, childGetter).then(
                    onCopySuccess,
                    onCopyFail,
                );
            }}
        >
            <div className={styles[state]} />
        </button>
    );
};

export default CopyIconButton;
